import { useMutation } from 'react-query';
import { previewAudience } from '../../services/audiences';

/**
 * Mutation hook to preview audience count for a given configuration.
 * Used for real-time count preview as the user modifies audience filters.
 */
export function useAudienceCount() {
  return useMutation(configuration => previewAudience({ configuration, loadingStatusOff: true }));
}

/**
 * Mutation hook to preview audience with client list.
 * Returns { total, clients[] } for displaying in a table.
 */
export function useAudiencePreview() {
  return useMutation(({ configuration, limit, offset, sort }) =>
    previewAudience({
      configuration,
      query: { include: 'clients', limit, offset, sort },
      loadingStatusOff: true,
    }),
  );
}
